import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotSeriesSection from './components/HotSeriesSection';
import FeatureSection from './components/FeatureSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotSeriesSection />
        <FeatureSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '好看的韩国漫画_韩漫在线免费阅读-尾巴漫画网',
            description: siteInfo.description,
            url: 'http://sansevieria.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '尾巴漫画网',
              url: 'http://sansevieria.cn/',
            },
            about: {
              '@type': 'Organization',
              name: '尾巴漫画网',
              url: 'http://sansevieria.cn/',
              foundingDate: '2020',
              description: siteInfo.description,
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页' },
              ],
            },
          }),
        }}
      />
    </>
  );
}